import React from 'react';
import { safeHTML } from '../../../../../utils/safeHTML';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import { useModal } from '../../../../../hooks/useModal';
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';
import AppLoader from '../../../../features/appLoader/AppLoader';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useTranslation, defaultStore, stores } from '../../../../../translations';
import content from '../../constants/content';
import { badWords } from '../../../wish';

const {
  presents: { title, text, buttons, modal },
} = content;

const Presents = React.forwardRef(function (_, ref) {
  const { addModal, closeModal } = useModal();
  const { t } = useTranslation();
  const callbacks = useApplicationCallbacks();
  const isPending = useRequestsHandlerData([
    {
      address: 'requestsUserGetUserData',
      fulfilled: ({ user: { uid } }) => {
        callbacks.getWishUserItems(uid);
      },
    },
    {
      address: 'requestsWishGetUserItems',
      fulfilled: ({ shopItems }) => {
        closeModal('all');
        addModal({ type: 'giftChoose', props: { shopItems } });
      },
    },
  ]);

  const onRecipient = ({ id }) => {
    callbacks.getUserData(id);
  };

  const buttonCallbacks = {
    look() {
      addModal({ type: 'myGiftModal' });
    },
    send() {
      addModal({
        type: 'wishModal',
        props: {
          ...modal,
          badWords: badWords[defaultStore] ?? badWords[stores.ru] ?? [],
          onSubmit: onRecipient,
        },
      });
    },
  };

  return (
    <div className={'friends__presents'}>
      <h2 className={'friends__presents-title'}>{safeHTML(t(title))}</h2>
      <p className={'friends__presents-text'}>{safeHTML(t(text))}</p>
      {buttons.map(({ action, attr }, id) => (
        <CustomButton key={`b${id}`} {...attr} onClick={buttonCallbacks[action]} />
      ))}
      {isPending && <AppLoader />}
    </div>
  );
});

export default Presents;
Presents.propTypes = {};
